import React, { Component } from 'react';
import ScrollMagic from 'scrollmagic';

import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap'
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators'

import './NotFound.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import renderHTML from 'react-render-html';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images
} from '../../settings';

import {
	DelayLink,
	AnimatedVideo
} from '../../components/';

class NotFound extends Component {

	constructor() {
		super();

        this.images = images;

        this.state = {
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	console.log('globalTransition');
    	Actions.globalTransition();
    }

	componentWillMount() {
    	Actions.menuHome();
    	Actions.logoIntern();
    	Actions.hideFooter();
    }

    componentDidMount() {
    }

	render() {
		var classItem = [
			'view',
			'notfound'
		];

        return (

			<div className="views">
			
				<Helmet>
	                <title>404 - Não encontrado - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className={ classItem.join(' ') }>
					<img src={ this.images.not_found } />

					<div className="not_found__text">
						<h2>Página não encontrada!</h2>
						<p>A página que você está procurando pode ter sido removida ou o link está incorreto.</p>
						<p className="back_p">voltar para <span onClick={ this.globalTransition }><DelayLink delay={ 1000 } to="/">Home</DelayLink></span></p>
					</div>
				</div>
    		</div>
    	);
	}
}

export { NotFound };
